module.exports = __webpack_public_path__ + "media/Trousers.692a4815.mp3";